"use strict";

/* Controllers */
angular
    .module("BannerFlowApp")
    .controller("FeedWizardController", function FeedWizardController($scope, $state, Feed) {
        $scope.steps = [
            {
                index: 1,
                title: "Feed source",
                url: "/legacy-app/views/Create/Feeds/Wizard/slide-1.html"
            },
            {
                index: 2,
                title: "Select fields",
                url: "/legacy-app/views/Create/Feeds/Wizard/slide-2.html"
            }
        ];

        $scope.currentSlide = $scope.steps[0].index;
        $scope.selectedFields = new Array();
        $scope.loading = false;
        $scope.previewRequestDeferer = null;
        $scope.errorText = "";
        $scope.showFeedExamples = false;

        $scope.feed = {
            name: "",
            feedData: "",
            properties: null
        };

        $scope.loadFeedExamples = function () {
            $scope.showFeedExamples = !$scope.showFeedExamples;
            $(window).on("mousedown", function (e) {
                if (
                    !$(e.target).is(".bf-action-menu") &&
                    !$(e.target).is(".toggle-feed-button") &&
                    !$(e.target).parents(".bf-action-menu").size()
                ) {
                    $scope.showFeedExamples = false;
                    $(window).off("mousedown");
                    $scope.$apply();
                }
            });
        };

        $scope.setFeedExample = function (e) {
            // Using [0] as it is setup for external feedsources that has that setup to set correct placeholders
            $scope.showFeedExamples = false;
            switch (e) {
                case "IGaming":
                    $scope.feed.source.metadata[0].data.value =
                        "https://play.bannerflow.com/dynamiccontent/examplefeeds/igaming.json";
                    break;
                case "Stocks":
                    $scope.feed.source.metadata[0].data.value =
                        "https://play.bannerflow.com/dynamiccontent/examplefeeds/stocks.json";
                    break;
                case "Travel":
                    $scope.feed.source.metadata[0].data.value =
                        "https://play.bannerflow.com/dynamiccontent/examplefeeds/travel.json";
                    break;
                case "E-Commerce":
                    $scope.feed.source.metadata[0].data.value =
                        "https://play.bannerflow.com/dynamiccontent/examplefeeds/ecom.json";
                    break;
                case "DCO":
                    $scope.feed.source.metadata[0].data.value =
                        "https://play.bannerflow.com/dynamiccontent/bannerflowDCOExample.json";
                    break;
                case "Translation":
                    $scope.feed.source.metadata[0].data.value =
                        "https://play.bannerflow.com/dynamiccontent/bannerflowTranslationExample.json";
                    break;
                case "Medical":
                    $scope.feed.source.metadata[0].data.value =
                        "https://play.bannerflow.com/dynamiccontent/examplefeeds/medical.json";
                    break;
                case "FX":
                    $scope.feed.source.metadata[0].data.value =
                        "https://play.bannerflow.com/dynamiccontent/examplefeeds/fx.json";
                    break;
                case "Entertainment":
                    $scope.feed.source.metadata[0].data.value =
                        "https://play.bannerflow.com/dynamiccontent/examplefeeds/entertainment.json";
                    break;
            }
        };

        $scope.setPlaceholder = function () {
            return ["ex. http://www.bannerflow.com/feed.xml"];
        };

        $scope.nextSlide = function () {
            $scope.slideAnimation = "wave-animation-reversed";

            $scope.feedFieldPickerStartNode = null;
            $scope.currentSlide++;

            if ($scope.currentSlide === 2) {
                $scope.fillFeedTree();
            }
        };

        $scope.prevSlide = function () {
            $scope.feedFieldPickerStartNode = null;
            $scope.currentSlide--;

            if ($scope.currentSlide === 2) {
                $scope.fillFeedTree();
            }
        };

        $scope.$watch(
            "selectedFields",
            function (n, o) {
                if (n === o) return;

                $scope.loadPreview();
            },
            true
        );

        $scope.feedFieldBrowserCallback = function () {};

        $scope.isDisabled = function () {
            if ($scope.currentSlide === 2 && $scope.selectedFields.length === 0) {
                return true;
            }

            if ($scope.currentSlide === 1) {
                var feed = $scope.feed;

                var feedNameIsInvalid = feed.name == "" || feed.name == null;

                var feedSourceMetadataIsInvalid = false;
                if (feed.source && feed.source.metadata) {
                    feed.source.metadata.forEach(function (metadata) {
                        if (
                            !metadata.isOptional &&
                            (metadata.data.value == null || metadata.data.value == "")
                        )
                            feedSourceMetadataIsInvalid = true;
                    });
                } else {
                    feedSourceMetadataIsInvalid = true;
                }

                return feedNameIsInvalid || feedSourceMetadataIsInvalid;
            }

            return false;
        };

        $scope.buildFeed = function () {
            $scope.feed.properties = new Array();

            for (var i = 0; i < $scope.selectedFields.length; i++) {
                var property = {
                    id: makeGUID(),
                    name: $scope.selectedFields[i].Name,
                    path: "$." + $scope.selectedFields[i].Path
                };

                $scope.feed.properties.push(property);
            }

            $scope.feed.interval = 86400;
        };

        $scope.createFeed = function () {
            $scope.loading = true;
            $scope.buildFeed();

            $scope.feed.folder = $scope.ngDialogData.folderId;

            const feed = new Feed($scope.feed);
            feed.$create(
                function (r) {
                    $scope.closeThisDialog();
                    $state.go("root.feeds.feed", { feedId: r.id });
                },
                function (r) {
                    console.error("Could not create feed!", r);
                }
            );
        };

        $scope.fillFeedTree = function () {
            $scope.errorText = "";
            $scope.feedPreview = null;
            $scope.feedTreeLoading = true;

            Feed.leafs(
                {
                    feedData: $scope.feed.feedData,
                    source: $scope.feed.source
                },
                function (response) {
                    const data = response.data;
                    if (data.error) {
                        $scope.errorText = data.errorMessage;
                        $scope.feedTreeLoading = false;
                        $scope.prevSlide();

                        return;
                    }

                    $scope.feedLeafs = data;
                    $scope.feedFieldPickerStartNode = $scope.feedLeafs;
                    $scope.feedPreview = new Array();
                    $scope.selectedFields = new Array();
                    $scope.feedTreeLoading = false;
                },
                function (response) {
                    $scope.errorText = response.data.errorMessage;
                    $scope.feedTreeLoading = false;
                    $scope.prevSlide();
                }
            );
        };

        $scope.loadPreview = function () {
            var previewList = new Array();
            for (var i = 0; i < $scope.selectedFields.length; i++) {
                var field = $scope.selectedFields[i];
                var fieldData = field.Data;
                for (var j = 0; j < 3; j++) {
                    if (!previewList[j])
                        previewList[j] = {
                            arr: new Array(),
                            id: makeGUID()
                        };

                    previewList[j].arr.push({
                        id: makeGUID(),
                        name: field.Name,
                        value: fieldData[j] ? fieldData[j] : fieldData[0]
                    });
                }
            }

            $scope.feedPreview = previewList;
        };

        function loadFeedSourceOptions() {
            $scope.loaded = false;
            Feed.getSourceOptions(
                {},
                function (response) {
                    $scope.feedSourceOptions = response;
                    $scope.feed.source = $scope.feedSourceOptions[0];

                    $scope.loaded = true;
                },
                function (response) {
                    $scope.loaded = true;
                    console.error("Failed to load feed source options!", response);
                }
            );
        }

        loadFeedSourceOptions();
    });
